import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules';
import { handleSwiperProgressBar } from '../modules/swiperModules';

const sections = document.querySelectorAll('section.reviews');

if (sections.length) {
    const createSwiper = element => {
        const paginationEl = element.querySelector('.slider-pagination');
        const slides = element.querySelectorAll('.swiper-slide');
        let args = {
            modules: [Mousewheel],
            direction: 'horizontal',
            mousewheel: {
                enabled: true,
                forceToAxis: true,
                invert: false,
            },
            breakpoints: {
                0: {
                    slidesPerView: slides.length === 1 ? 1 : 1.08,
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                },
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                },
                1023.98: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 20,
                },
            },
        };

        const swiper = new Swiper(element, args);

        if (paginationEl) {
            if (slides.length > 1) {
                handleSwiperProgressBar(paginationEl, swiper);

                paginationEl.parentElement.classList.remove('hidden');
            } else {
                paginationEl.parentElement.classList.add('hidden');
            }
        }
    };

    const onBulletChange = async (e, jsOutput, section, loader = null) => {
        try {
            loader?.classList.add('active');
            const formData = new FormData();
            formData.append('action', 'get_reviews');
            formData.append('term_slug', e.target.value);

            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });
            const res = await req.json();

            const { html } = res;

            if (html) {
                jsOutput.innerHTML = html;

                const slider = section.querySelector('.swiper');

                if (slider) {
                    createSwiper(slider);
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            loader?.classList.remove('active');
        }
    };

    sections.forEach(section => {
        const radioBullets = section.querySelectorAll(
            'input[name="review_cat"]'
        );
        const jsOutput = section.querySelector('[js-output]');
        const slider = section.querySelector('.swiper');
        const loader = section.querySelector('.loader');
        if (slider) {
            createSwiper(slider);
        }

        if (radioBullets && jsOutput) {
            radioBullets.forEach(bullet => {
                bullet.addEventListener('change', e =>
                    onBulletChange(e, jsOutput, section, loader)
                );
            });
        }
    });
}
